import { useContext, useEffect, useRef } from 'react'
import { GlobalContext } from 'App'

const First = ({ activeIndex }: any) => {
  const { isTablet } = useContext(GlobalContext)

  const videoRef = useRef<any>()
  useEffect(() => {
    if (activeIndex === 0) {
      setTimeout(() => {
        videoRef.current?.play()
      })
    } else {
      videoRef.current?.pause()
    }
  }, [activeIndex])

  const setPlayBackRate = () => {
    videoRef.current.playbackRate = 1
  }

  return (
    <div
      className={`flex bg-black w-full h-screen overflow-hidden justify-center items-center`}
      style={{ transition: 'all 2s ease-in' }}>
      <video
        className={`w-full h-full ${isTablet ? 'object-contain' : 'object-cover'}`}
        muted
        autoPlay
        loop
        playsInline
        controls={isTablet}
        ref={videoRef}
        onCanPlay={() => setPlayBackRate()}>
        <source src="/video/main.mp4" type="video/mp4" />
      </video>
    </div>
  )
}

export default First
